module.exports = __webpack_public_path__ + "img/27c700a9cb9603364c368aaf0aee65f3.svg";